module.exports = __webpack_public_path__ + "static/media/icon_arrow_left_bgc_dark.26155a6f.svg";